import { DatePicker } from '@fox/atoms/src/date-picker/index';
import { ISO_DATE_FORMAT } from '@fox/atoms/utils/date-functions';
import moment, { Moment } from 'moment';
import { FormRenderMode, QuestionStyleTypes } from '../../../form-runtime-context/contracts';
import { useFormRuntimeContext, useQuestionStyle } from '../../../form-runtime-context/form-runtime-context';
import { QuestionBlockProps } from '../contracts';
import { useDefaultAnswer } from '../default-answer-providers';

type IRenderDateQuestionProps = {
	inEditMode: boolean;
	questionName: string;
	id: string;
	fieldProps: QuestionBlockProps;
	defaultToday?: boolean;
};

export const RenderDateQuestion = (props: IRenderDateQuestionProps) => {
	const { inEditMode, questionName, id } = props;
	const { formRenderMode, getAnswer, answerQuestion } = useFormRuntimeContext();
	useDefaultAnswer(props.fieldProps, questionName, 'answerDate');

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, id);
	const answer = getAnswer(questionName)?.answer?.answerDate;

	const handleDateChange = (date: Moment | null) => {
		if (formRenderMode === FormRenderMode.design) {
			return;
		}
		const answerDate = date?.isValid() ? date.format(ISO_DATE_FORMAT) : undefined;
		answerQuestion({
			answer: {
				answerDate
			},
			questionName: questionName
		});
	};

	return inEditMode ? null : (
		<DatePicker
			size="small"
			onChange={handleDateChange}
			value={answer ? moment(answer) : null}
			sx={{
				'.MuiInputBase-root': {
					color,
					fontSize,
					fontStyle,
					fontFamily,
					textDecoration,
					fontWeight
				}
			}}
		/>
	);
};
